var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-353.000000, -373.000000)",
    fill: "#EC9741",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hold",
    transform: "translate(353.000000, 373.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,52.5 C12.1405965,52.5 0.5,40.8594035 0.5,26.5 C0.5,12.1405965 12.1405965,0.5 26.5,0.5 C40.8594035,0.5 52.5,12.1405965 52.5,26.5 C52.5,40.8594035 40.8594035,52.5 26.5,52.5 Z M19,18.5384615 L19,35.4615385 C19,36.8634921 19.8954305,38 21,38 C22.1045695,38 23,36.8634921 23,35.4615385 L23,18.5384615 C23,17.1365079 22.1045695,16 21,16 C19.8954305,16 19,17.1365079 19,18.5384615 Z M30,18.5384615 L30,35.4615385 C30,36.8634921 30.8954305,38 32,38 C33.1045695,38 34,36.8634921 34,35.4615385 L34,18.5384615 C34,17.1365079 33.1045695,16 32,16 C30.8954305,16 30,17.1365079 30,18.5384615 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhold);
export default __webpack_public_path__ + "static/media/unhold.eba7a0ef17dc7517a099005e721b2f97.svg";
export { ForwardRef as ReactComponent };